<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="Salir / Exit / Sair" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="goBack()"></button>
    </ng-template>
</p-toolbar>
<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span><b>240426- TRANSACTION:</b> {{transaction}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>Intente nuevamente ingresar al sistema!!!</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>Try again login to the system!!!</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>Tente novamente para entrar no sistema!!!</span>
                </div>


            </p-panel>
        </div>
    </div>
    <div class="p-col-12 p-md-6">
        <div class="pages-panel card p-d-flex p-flex-column">
            <div class="pages-header p-px-3 p-py-1">
                <h2>La sesión ha caducado o ha sido terminada / The session has expired or has been terminated / A sessão expirou ou foi encerrada</h2>
            </div>
            <div class="card p-mt-3 p-px-6">
                <img src="assets/layout/images/pages/error.png" alt=""/>
            </div>
        </div>
    </div>
</div>
